import { render, staticRenderFns } from "./CMChangePassword.vue?vue&type=template&id=5f844536&scoped=true&"
import script from "./CMChangePassword.vue?vue&type=script&lang=js&"
export * from "./CMChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./CMChangePassword.vue?vue&type=style&index=0&id=5f844536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f844536",
  null
  
)

export default component.exports